
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FAQs/[question]",
      function () {
        return require("private-next-pages/FAQs/[question].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FAQs/[question]"])
      });
    }
  